export const FileUploadTarget = {
  CHATROOM: 'chatroom',
  DOCUMENT: 'document',
  IMAGE: 'image'
}